import React, { Dispatch, memo, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { selectOptionsWrap } from "../../../../utils";
import MultiSelectWithModalBase, {
	MultiSelectWithModal,
} from "../MultiSelectWithModal";

const MultiSelectResponsibleDispatcherIdWithModalBase: React.FC<
	MultiSelectResponsibleDispatcherIdWithModalBase.Props
> = ({
	value,
	onChange,
	disabled,
	titleText,
	required,
	modalSetting,
	sort,
	all = true,
	showLable,
	showSelectAll = true,
	selectOptionsProps = [],
	...props
}) => {
	const { t } = useTranslation();

	const [error, setError] = useState("");

	const selectOptions = useMemo<MultiSelectWithModalBase.Value>(
		() =>
			selectOptionsProps.map((item) => ({
				key: item.key,
				label: item.label,
				value: item.value,
				name: item.label,
				data: item,
			})),
		[selectOptionsProps],
	);

	const selected = useMemo<MultiSelectWithModalBase.Value>(
		() =>
			selectOptions.filter((item) =>
				value.find((data) => data === item.value),
			),

		[selectOptions, value],
	);

	const selectOnChange = useCallback(
		(newValue) => {
			setError("");
			const Ids = newValue.map((item) => item.value);
			onChange(Ids);
		},
		[onChange],
	);

	const texts = useMemo(
		() => ({
			title: t(titleText),
			allText: t(["all_car_parks"]),
			allActiveText: t(["all_active_car_parks"]),
		}),
		[t, titleText],
	);

	return (
		<MultiSelectWithModal
			error={error}
			disabled={disabled}
			value={selected}
			title={texts.title}
			allText={all ? texts.allText : undefined}
			allActiveText={texts.allActiveText}
			options={selectOptions}
			onChange={selectOnChange}
			required={required}
			pullUpItemInsideArray
			hiddenButton={false}
			showSelectAll={showSelectAll}
			modalSetting={modalSetting}
			sort={{
				show: true,
				active: true,
				...(sort || {}),
			}}
			showLable={showLable}
			{...props}
		/>
	);
};

export const MultiSelectResponsibleDispatcherIdWithModal = memo(
	MultiSelectResponsibleDispatcherIdWithModalBase,
);

declare namespace MultiSelectResponsibleDispatcherIdWithModalBase {
	interface Props extends MultiSelectWithModalBase.Setting {
		value: Value;
		onChange: Dispatch<Value>;
		titleText: string | string[];
		modalSetting?: MultiSelectWithModalBase.ListSelectProps["modalSetting"];
		setShowModalProps?: (value: boolean) => void;

		all?: boolean;

		showLable?: boolean;
		showSelectAll?: boolean;
		selectOptionsProps: selectOptionsWrap.SelectOption[];
	}

	type Value = number[];
}

export default MultiSelectResponsibleDispatcherIdWithModalBase;
